import { useMutation } from 'react-query';
import { FairMarketValueConfigurationService } from '../../services/wealthlane-award-services';
import { CommaFormattedDecimal, CommaFormattedFloatPost } from '../../utils/global';
import { ACCEPT_DECIMAL } from '../../utils/apiDecimalConfig';

const useGetFMVconfigMarketPrice = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  awardType: string
): any => {
  return useMutation(
    async (payload: any) => {
      if (payload?.date) {
        return await handleRequest(
          FairMarketValueConfigurationService.getApiAwardApiAppFairMarketValueConfigurationMarketPrice(
            awardType,
            payload?.date
          )
        );
      }
    },
    {
      onSuccess: (response: any, context: any) => {
        const calculatedGrantPrice = response?.fmv * context?.issuedUnits.replaceAll(',', '');
        const roundedGrantPrice = Number(calculatedGrantPrice.toFixed(ACCEPT_DECIMAL));
        // Format Grant Price to string with 4 decimals and comma separators
        const formattedGrantPrice = roundedGrantPrice.toFixed(ACCEPT_DECIMAL);
        const [intPart, decPart] = formattedGrantPrice.split('.');
        const formattedGrantPriceWithCommas = `${Number(intPart).toLocaleString()}.${decPart}`;
        const formattedFmv = CommaFormattedDecimal(response?.fmv === null ? '' : response?.fmv);
        context?.setFieldValue(`employee.${context?.index}.marketValueAtGrant`, formattedFmv);
        context?.setFieldValue(
          `employee.${context?.index}.grantPrice`,
          formattedGrantPriceWithCommas
        );
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default useGetFMVconfigMarketPrice;
